import styled from 'styled-components';
import { Button } from 'shared-ui';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 340px;
  margin: 0 auto;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 32px 40px;
  background-color: #eff0f5;
  border-radius: 8px;
  width: 100%;
`;

export const IconWrapper = styled.div`
  margin-bottom: 16px;

  svg {
    width: 80px;
    height: 80px;
  }
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Description = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  max-width: 300px;
`;

export const AddLicenseButton = styled(Button)`
  margin-top: 16px;
`;
